import API from 'services/TAPS_API';

export default function getTypesOfLandUse(filter) {
  return API.request(
    {
      method: 'GET',
      url: `/dictionary/svi32`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      params: {
        filter: filter || '',
      },
    },
    true,
  );
}
